const REVEAL_CLASS_MAP = {
  up:           'animate-reveal-up',
  'up-short':   'animate-reveal-up-short',
  down:         'animate-reveal-down',
  'down-short': 'animate-reveal-down-short',
  left:         'animate-reveal-left',
  right:        'animate-reveal-right',
  fade:         'animate-reveal-fade',
  tile:         'animate-reveal-tile',
};

const mobileQuery = window.matchMedia('(max-width: 767px)');

function initScrollReveal() {
  const elements = document.querySelectorAll('[data-reveal]');
  if (!elements.length) return;

  const animating = new Set();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        const direction = el.dataset.reveal;
        const once = el.dataset.revealOnce === 'true';

        if (!entry.isIntersecting) {
          if (animating.has(el)) return;

          if (direction === 'letters') {
            el.querySelectorAll('span').forEach(span => {
              span.classList.remove('animate-reveal-letter');
              span.style.opacity = '0';
            });
          } else {
            const animClass = REVEAL_CLASS_MAP[direction];
            if (animClass) el.classList.remove(animClass);
            el.style.opacity = '0';
          }
          return;
        }

        if (direction === 'letters') {
          const stagger = parseInt(el.dataset.revealStagger, 10) || 40;
          const spans = el.querySelectorAll('span');
          animating.add(el);
          spans.forEach((span, i) => {
            setTimeout(() => {
              span.style.opacity = '';
              span.classList.add('animate-reveal-letter');
              if (i === spans.length - 1) {
                span.addEventListener('animationend', () => animating.delete(el), { once: true });
              }
            }, i * stagger);
          });
          if (once) observer.unobserve(el);
          return;
        }

        const animClass = REVEAL_CLASS_MAP[direction];
        const delay = parseInt(el.dataset.revealDelay, 10) || 0;

        if (!animClass) return;

        const apply = () => {
          animating.add(el);
          el.style.opacity = '';
          el.classList.add(animClass);
          el.addEventListener('animationend', () => animating.delete(el), { once: true });
        };

        delay > 0 ? setTimeout(apply, delay) : apply();

        if (once) observer.unobserve(el);
      });
    },
    { rootMargin: mobileQuery.matches ? '0px 0px -40px 0px' : '0px 0px -150px 0px', threshold: 0.1 }
  );

  elements.forEach((el) => {
    if ('revealNoMobile' in el.dataset && mobileQuery.matches) return;

    if (el.dataset.reveal === 'letters') {
      el.querySelectorAll('span').forEach(span => span.style.opacity = '0');
    } else {
      el.style.opacity = '0';
    }
    observer.observe(el);
  });
}

function initScanAnimate() {
  const el = document.querySelector('[data-scan-animate]');
  if (!el) return;

  el.addEventListener('animationend', (e) => {
    if (e.target === el && e.animationName === 'revealFromLeft') {
      el.classList.add('is-visible');
    }
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        el.classList.remove('is-visible');
      }
    });
  }, { rootMargin: '0px 0px -150px 0px', threshold: 0.1 });

  observer.observe(el);
}

function initStaggerReveal() {
  const containers = document.querySelectorAll('[data-reveal-stagger]');
  if (!containers.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const container = entry.target;
      const type = container.dataset.revealStagger || 'tile';
      const animClass = REVEAL_CLASS_MAP[type];
      const delayStep = parseInt(container.dataset.revealStaggerDelay, 10) || 200;
      const children = container.querySelectorAll('[data-reveal-child]');

      if (!entry.isIntersecting) {
        children.forEach((child) => {
          if (animClass) child.classList.remove(animClass);
          child.style.opacity = '0';
        });
        return;
      }

      children.forEach((child, i) => {
        setTimeout(() => {
          child.style.opacity = '';
          if (animClass) child.classList.add(animClass);
        }, i * delayStep);
      });
    });
  }, { rootMargin: '0px 0px -100px 0px', threshold: 0.1 });

  containers.forEach((container) => {
    const children = container.querySelectorAll('[data-reveal-child]');
    children.forEach((child) => { child.style.opacity = '0'; });
    observer.observe(container);
  });
}

function initObserve() {
  const els = document.querySelectorAll('[data-sp-observe]:not(.sp-animated)');
  if (!els.length) return;
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const delay = parseInt(entry.target.getAttribute('data-sp-observe-delay')) || 300;
        setTimeout(() => entry.target.classList.add('sp-animated'), delay);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });
  els.forEach((el) => obs.observe(el));
}

function initAll() {
  initScrollReveal();
  initStaggerReveal();
  initScanAnimate();
  initObserve();
}

// ── Curtain Reveal ──────────────────────────────────────────────────────────

function initCurtainReveal(root = document) {
  root.querySelectorAll('[data-curtain-reveal]').forEach(container => {
    const items = [...container.querySelectorAll('[data-curtain-item]')];
    if (!items.length) return;

    const delay     = parseInt(container.dataset.curtainDelay, 10) || 150;
    const threshold = parseFloat(container.dataset.curtainThreshold) || 0.15;
    const margin    = container.dataset.curtainMargin || '0px';
    let timers = [];

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          timers.forEach(t => clearTimeout(t));
          timers = [];
          items.forEach(item => item.querySelectorAll('.curtain').forEach(c => c.classList.remove('is-revealed')));
          return;
        }

        timers = [];
        items.forEach((item, i) => {
          timers.push(setTimeout(() => {
            item.querySelectorAll('.curtain').forEach(c => c.classList.add('is-revealed'));
          }, i * delay));
        });
      });
    }, { threshold, rootMargin: `0px 0px ${margin} 0px` });

    observer.observe(container);
  });
}

// ── Parallax ────────────────────────────────────────────────────────────────

let _parallaxItems = [];
let _parallaxBound = false;

function initParallax(root = document) {
  const found = [...root.querySelectorAll('[data-parallax]')];
  if (!found.length) return;
  _parallaxItems = [..._parallaxItems, ...found];
  if (_parallaxBound) return;
  _parallaxBound = true;

  function update() {
    const vh = window.innerHeight;
    _parallaxItems.forEach(el => {
      const rect   = el.getBoundingClientRect();
      const amount = mobileQuery.matches && el.dataset.parallaxMobile !== undefined
        ? parseFloat(el.dataset.parallaxMobile)
        : parseFloat(el.dataset.parallax) || 60;
      const speed    = parseFloat(el.dataset.parallaxSpeed) || 1;
      const progress = Math.max(0, Math.min(1, (vh - rect.top) / (vh / speed)));
      el.style.transform = `translateY(${-(amount * (1 - progress)).toFixed(2)}px)`;
    });
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
}

// ── TextBlurIn ──────────────────────────────────────────────────────────────

const _hoverMedia = window.matchMedia('(hover: hover)');

class TextBlurIn {
  constructor(el, listDelay = 0) {
    this.el = el;
    const delayOverride = el.dataset.blurDelay;
    this.listDelay = delayOverride !== undefined ? parseFloat(delayOverride) : listDelay;
    this.charDelay = parseFloat(el.dataset.blurCharDelay) || 22;
    this._revealed = false;
    this._split();
    this._observe();
    if (!('blurAuto' in this.el.dataset) && _hoverMedia.matches) {
      this._bindHover(this.el.closest('[data-blur-trigger]') ?? this.el.parentElement ?? this.el);
    }
  }

  _split() {
    let charIndex = 0;
    this._lastCharDelay = 0;
    const BLOCK = new Set(['H1','H2','H3','H4','H5','H6','P','DIV','SECTION']);
    const splitInPlace = (el) => {
      const children = [...el.childNodes];
      el.innerHTML = '';
      children.forEach(child => {
        if (child.nodeType === Node.TEXT_NODE) {
          const text = child.textContent.replace(/\s+/g, ' ').trim();
          if (!text) return;
          text.split(' ').forEach((word, wi, arr) => {
            if (word) {
              const wordSpan = document.createElement('span');
              wordSpan.classList.add('blur-word');
              [...word].forEach(char => {
                const span = document.createElement('span');
                span.classList.add('blur-char');
                const delay = this.listDelay + charIndex * this.charDelay;
                span.style.transitionDelay = `${delay}ms`;
                span._blurDelay = delay;
                this._lastCharDelay = delay;
                span.textContent = char;
                wordSpan.appendChild(span);
                charIndex++;
              });
              el.appendChild(wordSpan);
            }
            if (wi < arr.length - 1) {
              el.appendChild(document.createTextNode(' '));
              charIndex++;
            }
          });
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          if (child.tagName === 'BR') {
            el.appendChild(document.createElement('br'));
          } else if (BLOCK.has(child.tagName)) {
            const blockLabel = (child.innerText || child.textContent).replace(/\s+/g, ' ').trim();
            if (blockLabel) child.setAttribute('aria-label', blockLabel);
            splitInPlace(child);
            el.appendChild(child);
          } else {
            splitInPlace(child);
            el.appendChild(child);
          }
        }
      });
    };
    splitInPlace(this.el);
    this.spans = [...this.el.querySelectorAll('.blur-char')];
  }

  _observe() {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        const trigger = this.el.closest('[data-blur-trigger]') ?? this.el.parentElement;

        if (!e.isIntersecting) {
          if ('blurOnce' in this.el.dataset) return;
          this.el.classList.remove('focused');
          this._revealed = false;
          trigger?.classList.remove('blur-revealed');
          if (this._revealTimer) {
            clearTimeout(this._revealTimer);
            this._revealTimer = null;
          }
          if ('blurAuto' in this.el.dataset) {
            this._hovering = false;
            cancelAnimationFrame(this._raf);
            // transition:none shorthand overwrites transitionDelay longhands — restore them
            this.spans.forEach(s => {
              s.style.removeProperty('filter');
              s.style.transition = '';
              if (s._blurDelay !== undefined) s.style.transitionDelay = `${s._blurDelay}ms`;
            });
          }
          return;
        }

        this.el.classList.add('focused');
        // _lastCharDelay = actual delay of final char (accounts for space increments).
        // + 400ms transition + 200ms buffer so _startContinuous never races the last char.
        const revealDuration = this._lastCharDelay + 600;
        this._revealTimer = setTimeout(() => {
          this._revealTimer = null;
          if ('blurAuto' in this.el.dataset) {
            this._startContinuous();
          } else {
            this._revealed = true;
            trigger?.classList.add('blur-revealed');
            if ('blurOnce' in this.el.dataset) io.unobserve(this.el);
          }
        }, revealDuration);
      });
    }, { threshold: 0.2 });
    io.observe(this.el);
  }

  _startContinuous() {
    this.el.classList.add('focused');
    this._revealed = true;
    this.spans.forEach(s => {
      s.style.transition = 'none';
      s.style.setProperty('filter', 'blur(0px)', 'important');
    });
    this._hovering = true;
    this._hoverStart = null;
    this._raf = requestAnimationFrame(ts => this._tick(ts));
  }

  replay() {
    this._hovering = false;
    cancelAnimationFrame(this._raf);
    this._revealed = false;
    this.el.classList.remove('focused');
    // transition:none shorthand overwrites transitionDelay longhands — restore them
    this.spans.forEach(s => {
      s.style.transition = '';
      if (s._blurDelay !== undefined) s.style.transitionDelay = `${s._blurDelay}ms`;
      s.style.removeProperty('filter');
    });

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.el.classList.add('focused');
        if ('blurAuto' in this.el.dataset) {
          setTimeout(() => this._startContinuous(), this._lastCharDelay + 600);
        } else {
          this._revealed = true;
        }
      });
    });
  }

  _bindHover(trigger) {
    trigger.addEventListener('mouseenter', () => {
      if (!this._revealed) return;
      this._hovering = true;
      this._hoverStart = null;
      this.spans.forEach(s => s.style.transition = 'none');
      this._raf = requestAnimationFrame(ts => this._tick(ts));
    });

    trigger.addEventListener('mouseleave', () => {
      this._hovering = false;
      cancelAnimationFrame(this._raf);
      this.spans.forEach(s => {
        s.style.transition = '';
        s.style.removeProperty('filter');
      });
    });
  }

  _tick(ts) {
    if (!this._hovering) return;
    if (!this._hoverStart) this._hoverStart = ts;
    const elapsed = ts - this._hoverStart;
    const total = this.spans.length;
    const baseBlurs = [0.8, 1.5, 2.5, 3.5, 5];
    const RAMP = 350;
    const pulse = 0.2 + 0.3 * Math.sin(elapsed / 300);

    this.spans.forEach((span, i) => {
      const fromEnd = total - 1 - i;
      if (fromEnd < 5) {
        const idx = 4 - fromEnd;
        const charDelay = (4 - idx) * 60;
        const ramp = Math.min(1, Math.max(0, elapsed - charDelay) / RAMP);
        const scale = idx === 0 ? 1 : pulse;
        const blur = Math.max(0, baseBlurs[idx] * scale * ramp);
        span.style.setProperty('filter', `blur(${blur.toFixed(1)}px)`, 'important');
      }
    });

    this._raf = requestAnimationFrame(ts => this._tick(ts));
  }
}

function initTextBlurIn(root = document) {
  root.querySelectorAll('.text-blur-in').forEach((el, i) => {
    if (!el.dataset.blurInit) {
      el.dataset.blurInit = '1';
      el._blurIn = new TextBlurIn(el, i * 150);
    }
  });
}

// ── Boot ────────────────────────────────────────────────────────────────────

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initAll();
    initTextBlurIn();
    initCurtainReveal();
    initParallax();
  });
} else {
  initAll();
  initTextBlurIn();
  initCurtainReveal();
  initParallax();
}

document.addEventListener('shopify:section:load', (e) => {
  initAll();
  initTextBlurIn();
  initCurtainReveal(e.target);
  initParallax(e.target);
});

const _blurObserver = new MutationObserver(mutations => {
  for (const m of mutations) {
    for (const node of m.addedNodes) {
      if (node.nodeType !== 1) continue;
      const found = node.querySelectorAll?.('.text-blur-in') ?? [];
      found.forEach((el, i) => {
        if (!el.dataset.blurInit) {
          el.dataset.blurInit = '1';
          el._blurIn = new TextBlurIn(el, i * 150);
        }
      });
    }
  }
});
_blurObserver.observe(document.body, { childList: true, subtree: true });
